const getClientId = (origin) => {
	switch (origin) {
		case "https://gitdash.cfdata.org":
			return "341ff3595c666ac5b0fa161b4ca9c4d9968af79fa5da25d41d8b6305e12b012a";
		default:
			return "1ecb5d595f30aaeafeb4e49f922821461f9443f5226efcc0deca08819e86e88d";
	}
};

export const GITLAB_CLIENT_ID = getClientId(window.location.origin);
export const GITLAB_BASE_URL = "https://gitlab.cfdata.org";
export const GITLAB_GRAPHQL_URL = `${GITLAB_BASE_URL}/api/graphql?remove_deprecated=true`;
// remove_deprecated also hides experimental fields, such as
// MergeRequest.blockingMergeRequests; queries for those use this endpoint.
export const GITLAB_GRAPHQL_EXPERIMENTAL_URL = `${GITLAB_BASE_URL}/api/graphql`;
// Codiff mirrors GitLab's path structure, so MR links can be retargeted by
// swapping the origin. Display-only: the API and OIDC still talk to GitLab.
export const CODIFF_BASE_URL = "https://codiff.cloudflare.dev";
export const CODIFF_LINKS_STORAGE_KEY = "useCodiffLinks";
export const AI_CODE_REVIEWER_USERNAME = "gsa_claude";
export const MURLOC_REVIEWER_USERNAME = "gsa_murloc";
export const ITEMS_PER_PAGE = 10;
export const REFRESH_INTERVAL = 2 * 60 * 1000;

// View mode options for the dashboard
export const VIEW_MODE = Object.freeze({
	STANDARD: "standard",
	SWIMLANE: "swimlane",
	REVIEW_BOARD: "reviewboard",
	REPO: "repo",
	JIRA: "jira",
	COMMENT_ATTENTION: "comment-attention",
});

export const JIRA_BASE_URL = "https://jira.cfdata.org";
